<template>
  <v-select
    v-model="selectedColor"
    itemText="name"
    :items="colors"
    style="margin-top: 0; padding-top: 0; padding-bottom: 115px !important;"
    class="boxManuelNorm"
    appendIcon="null"
    :disabled="isCompletedOrLocked"
    @change="onchangeAnalysisNormColor"
  >
    <template v-slot:selection="{index, item}">
      <div
        :style="{ backgroundColor: manualNormColor(item.value), color: 'white'}"
        class="vignetteSelect"
        style="width: '100% !important'"
      >
        {{ item.message }}
        <v-icon
          class="boxManuelNorm__arrowRight"
        >
          mdi-chevron-down
        </v-icon>
      </div>
    </template>
    <template v-slot:item="{item}">
      <span
        class="boxManuelNorm__deployedListItem"
        :style="{ backgroundColor: manualNormColor(item.value)}"
        style=""
      >
        {{ item.message }}
      </span>
    </template>
  </v-select>
</template>

<script>
import Colors from '@/aquassist-shared/constants/workOrderAnalysis';

export default {
    name: 'ManualNorm',

    props: {
        value: {
            type: String,
            default: null,
        },
        isCompletedOrLocked: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            selectedColor: this.value,
        };
    },
    computed: {
        colors() {
            const colorsList = Colors.list.map(color => ({
                value: color === 'gray' ? null : color,
                name: this.$t(`colors.${color}`),
                message: this.$t(`workOrder.analysis.${color}`),
            }));
            return colorsList;
        },
    },

    mounted() {
        this.selectedColor = this.value;
    },

    methods: {
        onchangeAnalysisNormColor(item) {
            this.$emit('change', item);
        },
        manualNormColor(color) {
            if (color === 'green') {
                return '#2A750F';
            }
            if (color === 'yellow') {
                return '#D1A918';
            }
            if (color === 'orange') {
                return '#FF9800';
            }
            if (color === 'red') {
                return '#AD1C3F';
            }
            return 'grey';
        },
    },
};
</script>

<style lang="scss" scoped>
  .vignetteSelect {
    border-radius: 5px;
    width: 100%;
    color: black;
    font-size: 0.8rem;
    text-align: center;
    font-weight: 700;
    margin-bottom: 2px;
    height: 20px;
  }
  .boxManuelNorm__arrowRight {
    right: 0;
    margin-right: 5px;
    margin-top: 0px;
    padding-top: 0px;
    position: absolute;
    top : 1px;
    color: white
  }
  .boxManuelNorm__deployedListItem {
    width: 90%;
    margin-right: 5%;
    margin-left:5%;
    height: 20px;
    line-height: 17.5px;
    border-radius: 5px;
    text-align: center;
    color: white;
    font-weight: 700;
  }
</style>

<style lang="scss">
  .v-list-item:has(.boxManuelNorm__deployedListItem) {
    min-height: 30px !important;
    padding: 0 !important;
  }
  .boxManuelNorm {
    .v-input__append-inner{
      display: none;
      font-size: 0.8rem;
    }
  }


  .boxManuelNorm .v-input__slot:before {
    border: none !important;
  }

</style>
